import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./locale/i18n";
import { initGA } from "./utils/analytics";
import { initGTM, initFacebookPixel, initNaverAnalytics } from "./utils/tagManager";

// Analytics 초기화
initGA();
initGTM();
initFacebookPixel();
initNaverAnalytics();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
